import React, { useCallback } from 'react';

import { useCapacitor } from 'Util/Capacitors';

import { useClearByOnDemand } from '../Contexts/ClearByOnDemandProvider';
import ClearCompleteModalView from '../Components/ClearCompleteModal/ClearCompleteModal';

const ClearCompleteModal = () => {
  const { openUrl } = useCapacitor();

  const [, , { reset, getClearUrlLink }] = useClearByOnDemand();

  const onGoClearSite = useCallback(async () => {
    const fullURL = await getClearUrlLink();
    openUrl(fullURL, () => window.open(fullURL, '_blank'));
  }, [getClearUrlLink, openUrl]);

  return (
    <ClearCompleteModalView
      isOpen={true}
      onBackToClassroom={reset}
      onGoToClearSite={onGoClearSite}
    />
  );
};

export default ClearCompleteModal;
